const config = {
  // ✅ Production
  API_BASE_URL: "https://api.orca-helpdesk.online/api",

  // 🔧 Dev (i-uncomment kung mag-develop ka locally)
  // API_BASE_URL: "http://localhost:7057/",
};

export default config;